import { get, writable, derived } from 'svelte/store';
import { idb } from '../db.js';

const DB_TABLE = `pc_lists`; 

const initLists = () => {
    const { subscribe, set, update } = writable();
    const helpers = {
        init: async ( key, index ) => {
            // Default to get all lists if no index is set
            if( ! key ) {
                set(await idb.getAll( DB_TABLE ))
            // If just a key is provided return the record uid matches the key
            } else if ( ! index ){
                set([await idb.get( DB_TABLE, key)]);
            // If an index is also provide return the list of records where the index matches the key
            } else {
                set(await idb.getAllFromIndex.eq( DB_TABLE, index, key));
            }
        },
        add: ( data ) => { update( state => state.concat(data) )},
        find: ( uid ) => { get(lists).find( state => state.uid == uid) },
        editSingleField: async ( uid, field, data ) => { update( current => {
            console.group(`INFO: lists.editSingleField`);console.log(field, data);console.groupEnd();
            const index = current.findIndex( list => list.uid == uid);
            console.group(`INFO: lists.editSingleField`);console.log(index, current[index]);console.groupEnd();
            if(current[index]){
                current[index][field] = data;
                current[index].lastUpdated = Date.now();
                console.group(`INFO: lists.editSingleField`);console.log([...current]);console.groupEnd();
                return [ ...current ]
            }else{
                return current;
            }
            
        })},
        edit: ( uid, data ) => { update( state => {
            state[state.findIndex( state => state.uid == uid)] = data 
            return [...state]
        })},
        delete: async ( uid ) => { 
            update( current => current.filter( list => list.uid != uid) );
            idb.delete(DB_TABLE, uid );
        }
    }
    return {
        subscribe,
        set,
        update,
        ...helpers
    }
}
export const lists = initLists();